import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './components/footer/footer.component';
import { GeneralTableComponent } from './components/general-table/general-table.component';
import { MaterialModule } from '../core/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DialogDynamicComponent } from './components/dialog-dynamic/dialog-dynamic.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { GeneralDialogComponent } from './components/general-dialog/general-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { PortalModule } from '@angular/cdk/portal';
import { FaqManageComponent } from './components/faq-manage/faq-manage.component';
import { ResizeColumnDirective } from './directive/resize-column.directive';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { InputComponent } from './reusable/input/input.component';
import { DragDropComponent } from './reusable/drag-drop/drag-drop.component';
import { DisableControlDirective } from './directive/disable-control.directive';
import { DynamicFormComponent } from './reusable/dynamic-form/dynamic-form.component';
import { UserMappingComponent } from '../components/user-management/manage-users/users-mapping/users-mapping.component';
import { VendorViewComponent } from '../components/Vedors/vendor-view/vendor-view.component';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import { AutoCompleteComponent } from './components/auto-complete/auto-complete.component';
import {MatChipsModule} from '@angular/material/chips';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { AccountDetails } from './components/account-details/account-details.component';
import { GalleryDetails } from './components/gallery-details/gallery-details.component';
import { CreateOperator } from '../components/create-operator/create-operator-details.component';
import { LacMatTelInputModule } from 'lac-mat-tel-input';
import { DynamicTableComponent } from './components/dynamic-table/dynamic-table.component';
import { NgxDaterangepickerMd } from "ngx-daterangepicker-material";

export function httpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
    declarations: [VendorViewComponent, DynamicFormComponent, DisableControlDirective, InputComponent, DragDropComponent, FooterComponent, GeneralTableComponent, DialogDynamicComponent, DialogComponent, GeneralDialogComponent, ResizeColumnDirective, ConfirmDialogComponent, FaqManageComponent, UserMappingComponent, AutoCompleteComponent,AccountDetails,GalleryDetails,CreateOperator, DynamicTableComponent],
    imports: [MatTableModule, CommonModule, MatPaginatorModule, LacMatTelInputModule,
        MatSortModule, MaterialModule, FormsModule, ReactiveFormsModule, MatDialogModule, PortalModule, TranslateModule, NgxMaterialTimepickerModule, MatChipsModule,NgxDaterangepickerMd.forRoot(),
    ],
    exports: [
        VendorViewComponent, DynamicFormComponent, DisableControlDirective, DragDropComponent, FooterComponent, GeneralTableComponent, DialogDynamicComponent, DialogComponent, MatDialogModule, PortalModule,
        ResizeColumnDirective, ConfirmDialogComponent, FaqManageComponent, TranslateModule, InputComponent, UserMappingComponent, NgxMaterialTimepickerModule, AutoCompleteComponent, MatChipsModule,AccountDetails,GalleryDetails,CreateOperator,DynamicTableComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class SharedModule { }
